import { Download, LoaderCircle } from 'lucide-react';
import type { MediaKitAsset } from '../../lib/api/operatorConsole';
import { assetButtonLabel } from './mediaKitFormat';
import { useAssetDownload } from './useAssetDownload';

interface Props {
  packId: number;
  asset: MediaKitAsset;
  /** Whose asset this is, so the many "Photo 1" buttons stay distinguishable. */
  owner: string;
}

export function AssetDownloadButton({ packId, asset, owner }: Props) {
  const { pending, error, download } = useAssetDownload(packId, asset);
  const label = assetButtonLabel(asset);

  return (
    <div>
      <button
        type="button"
        onClick={() => void download()}
        disabled={pending}
        aria-busy={pending}
        aria-label={`Download ${label} — ${owner}`}
        title={asset.filename}
        className="flex w-full items-center gap-2 rounded-lg border border-[var(--co-border)] px-3 py-2 text-left text-[12px] font-medium text-[var(--co-text)] transition-colors hover:bg-[var(--co-bg)] disabled:cursor-wait disabled:opacity-60"
      >
        {pending ? (
          <LoaderCircle size={14} className="shrink-0 animate-spin" aria-hidden="true" />
        ) : (
          <Download size={14} className="shrink-0" aria-hidden="true" />
        )}
        <span className="truncate">{label}</span>
      </button>
      {error && (
        <p role="alert" className="mt-1 text-[11px] text-[var(--co-error)]">
          {error}
        </p>
      )}
    </div>
  );
}
